import { LMFormatterService } from '@list/formatters';
import { LMFormatUtilService } from '@services/utils';
import { LMProcessIndicatorService } from '../../field/processindicator/lm-process-indicator.service';
import { AppConstants } from '../../../utils';
import { LMListCardService } from '../services';
import {LMProcessIndicatorTooltipPipe} from '@field/processindicator/lm-process-indicator-tooltip.pipe';

export const lmListCellTooltip = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  lmProcessIndicatorService: LMProcessIndicatorService,
  lmProcessIndicatorTooltipPipe: LMProcessIndicatorTooltipPipe,
  lmListCardService: LMListCardService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  let tooltip = '';
  const listGridComponent = dataGrid.settings.userObject();

  if (columnDef.displayField.type === AppConstants.CARDVIEW) {
    if (columnDef.displayField.mainColumn) {
      const cardHTML = [];
      const card = lmListCardService.getCardTemplateData(columnDef.displayField, dataView);

      card.columns.forEach((column) => {
        column.column.forEach((field) => {
          if (!field.isProcessIndicator) {
            cardHTML.push(`<p>${field.displayValue}</p>`);
          }

          if (field.isProcessIndicator) {
            const templateData = lmProcessIndicatorService.getTemplateData(JSON.parse(field.displayValue));
            const current = lmProcessIndicatorService.getStepInProgress(templateData);
            const toolTipHTML = lmProcessIndicatorTooltipPipe.transform(current);
            const progressHTML = `
              <div style="margin: 15px 0;">
                <h1 style="font-weight: bold; font-size: 16px; color: #FFF; padding-bottom: 4px; border-bottom: 1px solid #FFF;">Current Step</h1>
                <div style="padding: 0 5px;">${toolTipHTML}</div>
              </div>
            `;

            cardHTML.push(`${progressHTML}`);
          }

        });
      })

      tooltip = `${cardHTML.join('')}`;
    } else {
      tooltip = '';
    }
  } else if (columnDef.displayField.isProcessIndicator) {
    const processIndicatorData: LMProcessIndicatorData = lmProcessIndicatorService.formatProcessIndicatorData(dataView, columnDef);
    const templateData = lmProcessIndicatorService.getTemplateData(processIndicatorData);
    const current = lmProcessIndicatorService.getStepInProgress(templateData);
    const toolTipHTML = lmProcessIndicatorTooltipPipe.transform(current);

    tooltip = `${toolTipHTML}`;
  } else if (columnDef.displayField.compactFormatByForm) {
    columnDef.flatLayout.elements.forEach((layoutField) => {

      let isVisible = true;
      let isValid = true;

      if (layoutField.field && layoutField.field.validity) {
        isValid = lmFormatterService.isConditionValid(layoutField.field.validity, dataView);
      }

      if (layoutField.field && layoutField.field.visibility) {
        isVisible = lmFormatterService.isConditionValid(layoutField.field.visibility, dataView);
      }

      if (isValid && isVisible) {
        const displayField = lmFormatterService.buildDisplayField(layoutField, dataView);
        const fieldValue = (dataView.fields[displayField.fieldId]) ? dataView.fields[displayField.fieldId].value : '';
        let displayValue = lmFormatterService.getDisplayText(displayField, fieldValue, dataView, listGridComponent.dataViewSet);

        if (lmFormatterService.isBlank(displayField.type, displayValue)) {
          displayValue =  '';
        }

        const label = lmFormatUtilService.formatMessageRule(displayField.label, dataView);

        tooltip = (tooltip.length > 0 ? tooltip + ' &#149; ' : tooltip) + label + (displayValue.length > 0 ? ': ' + displayValue : '');
      }
    });

  } else if (columnDef.displayField.displayAsProgressBar) {
    const ranges = columnDef.displayField.ranges;
    tooltip = lmFormatterService.getDisplayText(columnDef.displayField, value, dataView, dataGrid.settings.userObject().dataViewSet);

    if (ranges) {
      const rangeKeys = Object.keys(ranges);

      for (let i = 0; i < rangeKeys.length; i++){
        const key = rangeKeys[i];
        const r = ranges[ key ];

        if (r.tooltip){
          const min = (typeof r.start === 'string')
            ? dataView.fields[r.start].value
            : r.start;

          const max = (typeof r.end === 'string')
            ? dataView.fields[r.end].value
            : r.end;

          if (value >= min && value <= max){
            tooltip = lmFormatUtilService.formatMessageRule(r.tooltip, dataView);

            break;
          }
        } else {
          continue;
        }
      }
    }

  } else {
    tooltip = value;
  }
  return tooltip;
};
